<template>
  <div class="openFilter">
    <v-row class="ma-4 mb-0" style="min-height:70px; border-top: 1px solid #ccc; ">
      <v-col cols="12" class="" style="">
        <v-combobox
          v-model="seletedQuestion"
          :items="filterOptions.question_list"
          item-text="question"
          item-value="item"
          label="Questions"
          multiple
          outlined
          dense
        ></v-combobox>
      </v-col>
    </v-row>
    <v-row class="ma-4 mt-0" style="min-height:70px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; ">
      <v-col cols="3" class="" style="min-height:68px; border-right: 1px solid #ccc;">
        <v-combobox
          v-model="selectedDriver"
          :items="filterOptions.driver_list"
          label="Drivers"
          multiple
          outlined
          dense
          item-text="text"
          item-value="driver"
        ></v-combobox>
      </v-col>
      <v-col cols="3" class="" style="min-height:68px; border-right: 1px solid #ccc;">
        <v-combobox
          v-model="selectedSubdriver"
          :items="filterOptions.sub_driver_list"
          label="Sub drivers"
          multiple
          outlined
          dense
          item-text="text"
          item-value="subdriver"
        ></v-combobox>
      </v-col>
      <v-col cols="3" class=""  style="min-height:68px; border-right: 1px solid #ccc;">
        <v-combobox
          v-model="selectCriticalTP"
          :items="filterOptions.milestones_list"
          label="Critical touch points"
          multiple
          outlined
          dense
        ></v-combobox>
      </v-col>
      <v-col cols="3" class="" >
        <v-combobox
          v-model="selectedSentiment"
          :items="sentimentsFilters"
          label="Sentiment"
          outlined
          dense
        ></v-combobox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/*eslint-disable*/
// import EmployeesMixin from '../employee-mixin';
import axios from 'axios';
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'EmployeesSortbar',
  components: {
    // Qriousl
    InfiniteLoading
  },
  // mixins: [EmployeesMixin],

  //   props: {
  //     isFilterApplied: {
  //       required: true,
  //       type: Boolean
  //     }
  //   },

  data () {
    return {
      commentFilters: {},
      allCommentActive: true,
      sensitiveCommentActive: false,
      activeEmpView: 'active',
      filterOptions: [],
      allQuestions: [],
      comments: [],
      seletedQuestion: [],
      selectedDriver: [],
      selectedSubdriver: [],
      selectCriticalTP: [],
      selectedSentiment: '',
      filterOnQuestion: '',
      pagination: {
        rowsPerPage: 10,
        page: 1,
        length: 1
      },
      sentimentsFilters: ['positive', 'neutral', 'negative']
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  watch: {
    filterOptions: {
      // deep: true,
      handler () {
        if (this.filterOptions.driver_list && this.filterOptions.driver_list.length > 0) {
          const tempDriver = [];
          this.$lodash.each(this.filterOptions.driver_list, (val) => {
            const temp = {};
            temp.text = val.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
            temp.driver = val;
            tempDriver.push(temp);
          });
          this.filterOptions.driver_list = tempDriver;
        }
        if (this.filterOptions.sub_driver_list && this.filterOptions.sub_driver_list.length > 0) {
          const tempSubDriver = [];
          this.$lodash.each(this.filterOptions.sub_driver_list, (val) => {
            const temp = {};
            temp.text = val.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
            temp.subdriver = val;
            tempSubDriver.push(temp);
          });
          this.filterOptions.sub_driver_list = tempSubDriver;
        }
      }
    },
    seletedQuestion: {
      deep: true,
      handler () {
        // this.selectedDriver = [];
        // this.selectedSubdriver = [];
        if (this.seletedQuestion.length > 5) {
          this.$nextTick(() => this.seletedQuestion.pop())
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'You can not select more than 5 queastions!'
          });
        } else {
          this.$lodash.each(this.seletedQuestion, (ql) => {
          // this.$lodash.each(this.filterOptions.question_list, (q) => {
          //   if (q.question === ql) {
          const idx = this.selectedDriver.findIndex(d => d.driver === ql.driver);
          // console.log(this.seletedQuestion);
          if (idx === -1) {
            const temp = {};
            temp.text = ql.driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
            temp.driver = ql.driver;
            this.selectedDriver.push(temp);
          }
          const idx1 = this.selectedSubdriver.findIndex(d1 => d1.subdriver === ql.sub_driver);
          if (idx1 === -1) {
            const temp = {};
            temp.text = ql.sub_driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
            temp.subdriver = ql.sub_driver;
            this.selectedSubdriver.push(temp);
          }
        });
        }
        this.pagination.page = 1;
        this.comments = [];
        this.getComments();
      }
    },
    selectedDriver: {
      deep: true,
      handler () {
        this.pagination.page = 1;
        this.comments = [];
        this.$emit('onGetComments');
        // this.getComments();
      }
    },
    selectedSubdriver: {
      deep: true,
      handler () {
        this.pagination.page = 1;
        this.comments = [];
        this.$emit('onGetComments');
        // this.getComments();
      }
    },
    selectCriticalTP: {
      deep: true,
      handler () {
        this.pagination.page = 1;
        this.comments = [];
        // this.getComments();
        this.$emit('onGetComments');
      }
    },
    selectedSentiment: {
      deep: true,
      handler () {
        this.pagination.page = 1;
        this.comments = [];
        // this.getComments();
        this.$emit('onGetComments');
      }
    },
    $route: {
      immediate: true,
      deep: true,
      handler () {
        this.updateRoute();
      }
    }
  },
  methods: {
    updateRoute () {
      if (this.$route && this.$route.query && this.$route.query.driver) {
        this.selectedDriver = [];
        const t = {};
        t.text = this.$route.query.driver.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
        t.driver = this.$route.query.driver;
        this.selectedDriver.push(t);
      }
      if (this.$route && this.$route.query && this.$route.query.subdriver) {
        this.selectedSubdriver = [];
        const t = {};
        t.text = this.$route.query.subdriver.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
        t.subdriver = this.$route.query.subdriver;
        this.selectedSubdriver.push(t);
      }
      if (this.$route.query && this.$route.query.filters) {
        const updateDashboardFilters = JSON.parse(this.$route.query.filters);
        if (updateDashboardFilters && updateDashboardFilters.stage__title__in) {
          this.selectCriticalTP = [];
          this.selectCriticalTP = updateDashboardFilters.stage__title__in.split(',');
        }
      }
      if (this.$route && this.$route.query && this.$route.query.question && this.$route.query.question !== '') {
        this.selectedDriver = [];
        this.selectedSubdriver = [];
        const t = {};
        t.sub_driver = this.$route.query.subdriver;
        t.driver = this.$route.query.driver;
        t.question = this.$route.query.question;
        this.seletedQuestion.push(t);
      }
    },
    getCommentFilters () {
    //   const queryParams = {
    //     options: 'sort_option,filter_options',
    //     report_name: 'chat_response_rate'
    //   };
      axios.get(`${process.env.VUE_APP_API_URL}response/filters`, {
        // params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.filterOptions = response.data;
          this.$lodash.each(this.filterOptions.question_list, (ql) => {
            this.allQuestions.push(ql.question);
          });
        //   this.sortOptions = response.data.queryset_sort_options;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get filter, Please try again later!'
          });
        }
      });
    },
    getCommentsType (val) {
      this.sensitiveCommentActive = val;
    },
    fixedEncodeURIComponent (str) {
      return encodeURIComponent(str).replace(/[!'()*]/g, (c) => {
        return '%' + c.charCodeAt(0).toString(16);
      });
    },
    getComments ($state) {
      // if ($state) {
        let queryParams = {
          count: 'true',
          page_limit: this.pagination.rowsPerPage,
          page_offset: this.pagination.page || 1,
          sensitive_comments: this.sensitiveCommentActive === true ? this.sensitiveCommentActive : undefined,
          milestone: this.selectCriticalTP && this.selectCriticalTP.length > 0 ? this.selectCriticalTP.join(',') : undefined,
          sentiment: this.selectedSentiment ? this.selectedSentiment : undefined
        };
        const tempQuestion = [];
        this.$lodash.each(this.seletedQuestion, (sl) => {
          const q = this.fixedEncodeURIComponent(sl.question);
          tempQuestion.push(q);
        });
        queryParams.question = tempQuestion && tempQuestion.length > 0 ? tempQuestion.join('||') : undefined;
        const sortData = {
          milestone: this.selectCriticalTP && this.selectCriticalTP.length > 0 ? this.selectCriticalTP.join(',') : undefined,
          sentiment: this.selectedSentiment ? this.selectedSentiment : undefined,
          question: tempQuestion && tempQuestion.length > 0 ? tempQuestion.join('||') : undefined
        };
        const tempDriver = [];
        this.$lodash.each(this.selectedDriver, (val) => {
          tempDriver.push(val.driver);
        });
        const tempSubDriver = [];
        this.$lodash.each(this.selectedSubdriver, (val) => {
          tempSubDriver.push(val.subdriver);
        });
        sortData.driver = tempDriver && tempDriver.length > 0 ? tempDriver.join(',') : undefined;
        queryParams.driver = tempDriver && tempDriver.length > 0 ? tempDriver.join(',') : undefined;
        sortData.sub_driver = tempSubDriver && tempSubDriver.length > 0 ? tempSubDriver.join(',') : undefined;
        queryParams.sub_driver = tempSubDriver && tempSubDriver.length > 0 ? tempSubDriver.join(',') : undefined;
        this.$emit('sortbarData', sortData);
        let commentFilters = {};
        if (this.$route && this.$route.query && this.$route.query.filters) {  
          commentFilters = JSON.parse(this.$route.query.filters);
        }
        const filters = Object.assign({}, commentFilters);
        if (filters && filters.filters) {
          delete filters.filters;
        }
        queryParams = {
          ...queryParams,
          ...filters
        };
        if (commentFilters && commentFilters.filters) {
          this.$lodash.each(commentFilters.filters, (v, k) => {
            if (v.length > 0 && k !== 'session__stage__title') {
              queryParams[`user__profile__${k}__in`] = v.join();
            }
            if (v.length > 0 && k === 'session__stage__title') {
              queryParams['stage__title__in'] = v.join();
            }
          });
        }
        // if (queryParams.question) {
        //   // queryParams.question = queryParams.question.replace(') ', ')').replace(' (', '(');
        //   queryParams.question = this.fixedEncodeURIComponent(queryParams.question);
        // }
        axios.get(`${process.env.VUE_APP_API_URL}response/list`, {
          params: queryParams
          // question: this.seletedQuestion
        }).then((response) => {
            if (response.data) {
              this.$emit('totalResponses', response.data.total_responses);
              if (this.pagination.page === 1 || queryParams.page_offset === 1) {
                this.comments = [];
                this.$emit('allComment', this.comments);
              }
              if (response.data.total_responses > this.comments.length) {
                if ($state) {
                  this.pagination.page += 1;
                }
                // console.log('this.comments = [];', this.comments);
                const temp = [];
                if (this.comments.length > 0) {
                  this.$lodash.each(this.comments, (val) => {
                    temp.push(val);
                  });
                }
                this.$lodash.each(response.data.response_list, (val) => {
                  temp.push(val);
                });
                // this.comments = [];
                // this.$emit('allComment', this.comments);
                this.comments = temp;
                this.$emit('allComment', this.comments);
                if ($state) {
                  $state.loaded();
                }
              } else {
                $state.complete();
              }
            }
        }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
      // }
    },
    getSensetiveComment () {
      this.sensitiveCommentActive = true;
      this.allCommentActive = false;
    }
  },
  beforeMount () {
    this.getCommentFilters();
    this.updateRoute();
    console.log(this.$route.query.stage);
    if (this.$route.query.stage) {
      this.selectCriticalTP = [this.$route.query.stage];
    }
  }
};
</script>

<style  lang="scss">
.openFilter {
  .v-select__selections {
    max-height: 100px;
    overflow-y: auto;
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.top-nav {
  // position: relative;
  padding: 12px 12px 0;
  background: #584475;
  background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      position: relative;
      cursor: pointer;
      a {
        text-decoration: none;
      }
      .top-menu {
        // height: 55px;
        height: 48px;
        // border-top-left-radius: 0.375rem;
        border-top-left-radius: 0.5rem;
        // border-top-right-radius: 0.375rem;
        border-top-right-radius: 0.5rem;
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        // margin-right: 0.5rem;
        margin-right: 0.25rem;
        // color: var(--color-text);
        color: var(--bg);
        font-size: var(--content-size);
        position: relative;
        .top-menu__title {
          margin-left: 0.25rem;
          display: flex;
          align-items: center;
          white-space: nowrap;
          .top-menu__sub-icon {
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
            width: 1rem;
            height: 1rem;
            margin-left: 0.5rem;
          }
        }
        &.top-menu--active {
          display: flex;
          background-color: #faf8fb;
          color: var(--primary-color);
          .top-menu__icon {
            color: var(--primary-dark);;
          }
          .top-menu__title {
            color: var(--color-headings);
            font-weight: var(--heading-weight);
          }
          &::before {
            content: "";
            width: 20px;
            height: 20px;
            margin-left: -20px;
            transform: rotate(90deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            left: 0;
          }
          &::after {
            content: "";
            width: 20px;
            height: 20px;
            margin-right: -20px;
            transform: rotate(180deg) scale(1.04);
            background-size: 100%;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='259.51' height='259.52' viewBox='0 0 259.51 259.52'%3E%3Cpath id='Path_143' data-name='Path 143' d='M8659.507,423.965c-.167-2.608.05-5.319-.19-8.211-.084-1.012-.031-2.15-.118-3.12-.113-1.25-.1-2.682-.236-4.061-.172-1.722-.179-3.757-.365-5.394-.328-2.889-.478-5.857-.854-8.61-.509-3.714-.825-7.252-1.38-10.543-.934-5.535-2.009-11.312-3.189-16.692-.855-3.9-1.772-7.416-2.752-11.2-1.1-4.256-2.394-8.149-3.687-12.381-1.1-3.615-2.366-6.893-3.623-10.493-1.3-3.739-2.917-7.26-4.284-10.7-1.708-4.295-3.674-8.078-5.485-12.023-1.145-2.493-2.5-4.932-3.727-7.387-1.318-2.646-2.9-5.214-4.152-7.518-1.716-3.16-3.517-5.946-5.274-8.873-1.692-2.818-3.589-5.645-5.355-8.334-2.326-3.542-4.637-6.581-7.039-9.848-2.064-2.809-4.017-5.255-6.088-7.828-2.394-2.974-4.937-5.936-7.292-8.589-3.027-3.411-6.049-6.744-9.055-9.763-2.4-2.412-4.776-4.822-7.108-6.975-3-2.767-5.836-5.471-8.692-7.854-3.332-2.779-6.657-5.663-9.815-8.028-2.958-2.216-5.784-4.613-8.7-6.6-3.161-2.159-6.251-4.414-9.219-6.254-3.814-2.365-7.533-4.882-11.168-6.89-4.213-2.327-8.513-4.909-12.478-6.834-4.61-2.239-9.234-4.619-13.51-6.416-4.1-1.725-8.11-3.505-11.874-4.888-4.5-1.652-8.506-3.191-12.584-4.47-6.045-1.9-12.071-3.678-17.431-5-9.228-2.284-17.608-3.757-24.951-4.9-7.123-1.112-13.437-1.64-18.271-2.035l-2.405-.2c-1.638-.136-3.508-.237-4.633-.3a115.051,115.051,0,0,0-12.526-.227h259.51Z' transform='translate(-8399.997 -164.445)' fill='%23faf8fb'/%3E%3C/svg%3E%0A");
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
        &:not(.top-menu--active) .top-menu__icon:before {
          content: "";
          z-index: -1;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-top-left-radius: 0.5rem;
          border-top-right-radius: 0.5rem;
          transition-property: background-color,
          border-color, color, fill, stroke, opacity, box-shadow, transform;
          transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
          transition-duration: 100ms;
        }
      }
      @keyframes intro-active-menu-animation {
        100% {
          z-index: 0;
        }
      }
      @keyframes intro-menu-animation {
        100% {
          opacity: 1;
          transform: translateX(0px);
        }
      }
      &:hover .top-menu:not(.top-menu--active) {
        // background-color: var(--bg-panel);
        background-color: var(--bg);
        background-color: #dde2e9;
        background-color: #fbfcff;
        background-color: #faf8fb;
        color: var(--primary-color);
      }
      &:hover .dropdown {
        display: block;
      }
      .dropdown {
        list-style: none;
        margin: 0;
        padding: 0.5rem !important;
        // background-color: var(--primary-dark);
        background: rgb(52,43,126);
        background: linear-gradient(150deg, rgba(52,43,126,1) 0%, rgba(84,72,189,1) 70%, rgba(143,72,189,1) 100%, rgba(197,36,55,1) 100%);
        -webkit-box-shadow: 0 3px 20px rgba(0,0,0,.04);
        box-shadow: 0 3px 20px rgba(0,0,0,.04);
        display: none;
        width: 100%;
        position: absolute;
        border-radius: .375rem;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        z-index: 20;
        li {
          cursor: pointer;
          position: relative;
          .top-menu-side {
            height: 55px;
            border-top-left-radius: 1rem;
            border-top-right-radius: 1rem;
            display: flex;
            align-items: center;
            padding-left: 0;
            padding-right: 0;
            margin-right: 0;
            --text-opacity: 1;
            color: #fff;
            color: rgba(255, 255, 255, var(--text-opacity));
            position: relative;
            width: 100%;
            padding-left: 1.25rem !important;
            .top-menu__title {
              width: 100%;
              margin-left: 0.5rem;
              display: flex;
              align-items: center;
              white-space: nowrap;
              // color: #9f88f1;
              opacity: 0.75;
            }
            // .top-menu__icon:before {
            //   content: "";
            //   z-index: -1;
            //   position: absolute;
            //   width: 100%;
            //   height: 100%;
            //   top: 0;
            //   left: 0;
            //   border-radius: 0.5rem;
            //   transition-property: background-color,
            //   border-color, color, fill, stroke, opacity, box-shadow, transform;
            //   transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            //   transition-duration: 100ms;
            // }
          }
          &:hover .top-menu-side {
            color: var(--color-text);
            font-weight: var(--heading-weight);
            transition-property: background-color,
            border-color, color, fill, stroke, opacity, box-shadow, transform;
            transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
            transition-duration: 100ms;
          }
          &:hover {
            transition: 0.5s ease;
            .top-menu__title {
              color: var(--bg);
              opacity: 1;
            }
            background-color: rgba(0, 0, 0, 0.04);
          }
        }
      }
    }
  }
}
</style>
